<template>
  <div class="choice-group row">
    <template v-if="confirmationStatus === 0">
      <div id="tracking-replace-title" class="col-md-12 title">
        {{ $t('tracking.replacing.title') }}
      </div>
      <div class="col-md-12 description">
        {{ $t('tracking.replacing.parcelshop') }} :
        <b v-if="unavailableLabel">{{ unavailableLabel }}</b>
        {{ $t('tracking.replacing.parcelshopUnavailable') }}<br />
        {{ $t('tracking.replacing.options') }} :
      </div>
      <div class="choice col-md-3" @click="selectOption(2)" v-if="hasOptionChange">
        <input type="radio" />
        <label :class="{ hightlighted: selectedOption === 2 }">
          <span class="radio-button" :class="{ selected: selectedOption === 2 }"></span>
          {{ $t('tracking.replacing.chooseAnotherParcelshop') }}* <br />
          {{ $t('tracking.replacing.delivery') }}.
        </label>
      </div>
      <div class="choice col-md-3" @click="selectOption(1)" v-if="hasOptionWait">
        <input type="radio" id="ChoiceOne" />
        <label for="ChoiceOne" :class="{ hightlighted: selectedOption === 1 }">
          <span class="radio-button" :class="{ selected: selectedOption === 1 }"></span>
          {{ $t('tracking.replacing.wait') }}
        </label>
      </div>
      <div class="col-md-12 instructions" v-if="selectedOption">
        <div class="star">*{{ $t('tracking.replacing.unavailability') }}</div>
        <div v-if="selectedOption === 1">
          <p>
            {{ $t('tracking.replacing.waitParcelshop') }}
            {{ unavailableParcelshop != null ? unavailableParcelshop.Libelle : ''
            }}{{ getReOpenDate }}.
          </p>
          <p>{{ $t('tracking.replacing.notification') }}</p>
          <button type="button" class="btn green" @click="confirmReplacing(1)">
            {{ $t('tracking.replacing.confirmWait') }}
          </button>
        </div>
        <div v-if="selectedOption === 2">
          <p>{{ $t('tracking.replacing.selectionInstructions') }}</p>
          <ParcelshopPicker
            id="parcelshop-picker"
            :enable-selection="true"
            :enable-pricing="false"
            :selectionMode="true"
            :postcode="
              unavailableParcelshop != null && unavailableParcelshop.CodePostal != null
                ? unavailableParcelshop.CodePostal
                : $store.state.destinataireCodePostal
            "
            :town="unavailableParcelshop != null ? unavailableParcelshop.Ville : ''"
            :country-code="$store.state.deliveryCountry"
            :numeroUnavailableParcelshop="
              unavailableParcelshop != null ? unavailableParcelshop.Numero : ''
            "
            :enable-refresh-on-move="true"
            @parcelshop-selected="selectNewParcelshop($event)"
            :showFilterPrintInStore="false"
            :showFilterLocker="$store.state.showFilterLocker"
            :parcelshopNatureAllowed="availableNatures"
            :avoidSaturated="true"
            :isPrintInStoreHighlighted="false"
            :parcelshopAgenceAllowed="
              unavailableParcelshop != null
                ? unavailableParcelshop.Agence
                : $store.state.codeAgenceLivraison
            "
            :relayPointsExcluded="$store.state.relayPointsExcluded"
          />
          <div class="tracking-replace-container">
            <p>{{ $t('tracking.replacing.switchParcelshop') }}</p>
            <p>{{ $t('tracking.replacing.notification') }}</p>
            <template v-if="selectedParcelshop && selectedParcelshop.Numero">
              <button type="button" class="btn green tracking-replace-btn" @click="handleClick">
                {{
                  $t('tracking.replacing.confirmSwitch') +
                  ` (${selectedParcelshop.Adresse.Libelle})`
                }}
              </button>
            </template>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <ConfirmationMessage :parcelshop="selectedParcelshop" />
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ConfirmationMessage from '../ConfirmationMessage/ConfirmationMessage';
import ParcelshopPicker from '../../../../parcelshop-picker/src/components/ParcelshopPicker/ParcelshopPicker.vue';

export default {
  components: {
    ConfirmationMessage,
    ParcelshopPicker,
  },
  props: {
    unavailableParcelshop: Object,
  },
  data() {
    return {
      selectedOption: 0,
      selectedParcelshop: null,
      availableNatures: '',
    };
  },
  created() {
    this.availableNatures = this.$store.state.authorizedNatures;
  },
  mounted() {
    this.$store.commit('setSelectionMode', true);
    this.$store.commit('setSaturatedParams', true);

    const agence =
      this.unavailableParcelshop && this.unavailableParcelshop.Agence
        ? this.unavailableParcelshop.Agence
        : this.$store.state.codeAgenceLivraison;

    this.$store.commit('setParcelshopAgenceAllowed', agence);
  },
  computed: {
    ...mapState([
      'allowedOperations',
      'confirmationStatus',
      'finalDestination',
      'destinataireCodePostal',
    ]),
    reOpenDateLabel: function () {
      const date = this.finalDestination && this.finalDestination.DateReouverture;
      if (!date) return null;

      const d = new Date(date);
      if (Number.isNaN(d.getTime())) return null;

      const formatted = d.toLocaleDateString('fr-FR');
      return ` ${this.$t('tracking.replacing.theDate')} ${formatted}`;
    },
    unavailableLabel() {
      if (!this.unavailableParcelshop) return '';
      const { Libelle, Ville } = this.unavailableParcelshop;
      return `${Libelle} ${Ville}`;
    },
    hasOptionChange() {
      return Array.isArray(this.allowedOperations) && this.allowedOperations.includes(2);
    },
    hasOptionWait() {
      return Array.isArray(this.allowedOperations) && this.allowedOperations.includes(1);
    },
  },
  methods: {
    selectOption(option) {
      this.selectedOption = option;
    },
    selectNewParcelshop(parcelshop) {
      if (!parcelshop || parcelshop.isUnavailable) return;
      this.selectedParcelshop = parcelshop;
    },
    confirmReplacing(replacingOption) {
      let parcelshopId = '';

      if (
        replacingOption === 2 &&
        this.selectedParcelshop &&
        this.selectedParcelshop.Adresse &&
        this.selectedParcelshop.Adresse.Pays &&
        this.selectedParcelshop.Adresse.Pays.Code &&
        this.selectedParcelshop.Numero
      ) {
        parcelshopId = `${this.selectedParcelshop.Adresse.Pays.Code}-${this.selectedParcelshop.Numero}`;
      }

      this.$store.dispatch('confirmReplacing', {
        replacingOption,
        parcelshopId,
      });
    },
    handleClick() {
      this.confirmReplacing(2);

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import './Replacing.scss';
</style>
